export default __webpack_public_path__ + "static/media/apple-icloud-logo.6b3ba3fa.png";